function injectStyle (ssrContext) {
  require("!!../../../node_modules/.store/extract-text-webpack-plugin@3.0.2/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-2b6b4606\",\"scoped\":true,\"hasInlineConfig\":false}!less-loader?{\"globalVars\":{\"themeColor\":\"#ff0129\",\"bgColor\":\"#f5f5f5\",\"greenColor\":\"#2cd29d\",\"yellowColor\":\"#f2c13d\",\"redColor\":\"#f5486d\",\"grayColor\":\"#dddae2\",\"textColor\":\"#62605f\",\"textColor1\":\"#1d2438\",\"textColor2\":\"#80848f\",\"textColor3\":\"#bcbec4\",\"textColor4\":\"#d7d9df\",\"textSize36\":\"4.32vw\",\"textSize30\":\"3.6vw\",\"textSize28\":\"3.36vw\",\"textSize26\":\"3.12vw\",\"textSize24\":\"2.88vw\"},\"sourceMap\":true}!../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=styles&index=0!./Charge.vue")
}
var normalizeComponent = require("!../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=script&index=0!./Charge.vue"
import __vue_script__ from "!!babel-loader!../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=script&index=0!./Charge.vue"
/* template */
import __vue_template__ from "!!../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-2b6b4606\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../node_modules/.store/vue-loader@13.7.3/node_modules/vue-loader/lib/selector?type=template&index=0!./Charge.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b6b4606"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/wenhuajifen/Charge.vue
// module id = null
// module chunks = 